import { configureStore } from "@reduxjs/toolkit";

import formsReducer from '../../../Components/UI/Form/store/forms-reducer';
import imageReducer from '../store/image';
import keyValueStore from '../store/keyValueStore';
import configStore from '../../../lib/configStore';

export const store = configureStore({
  reducer: {
    forms: formsReducer,
    img: imageReducer,
    keyValueStore: keyValueStore,
    config: configStore,
  }
});
